

const AUTO_PLAY_BREAKPOINT = 1199;

const shouldAutoPlayOnView = () => window.innerWidth <= AUTO_PLAY_BREAKPOINT;

const noop = () => {};

export function initWirkungVideos() {
  const videos = Array.from(document.querySelectorAll('.wirkung-vid'));
  if (!videos.length) return;

  videos.forEach(video => {
    const wrapper = video.closest('.wirkung-card-wrapper');
    const imageSection = video.closest('.wirkung-image-section');
    const cardContent = video.closest('.wirkung-card-content');

    video.loop = true;
    video.muted = true;
    video.pause();
    video.currentTime = 0;

    const setPlayingState = (isPlaying) => {
      if (isPlaying) {
        video.classList.add('is-playing');
        imageSection?.classList.add('is-video-playing');
      } else {
        video.classList.remove('is-playing');
        imageSection?.classList.remove('is-video-playing');
      }
    };

    const playVideo = () => {
      setPlayingState(true);
      video.play().catch(noop);
    };
    const pauseVideo = () => {
      setPlayingState(false);
      video.pause();
    };

    const trigger = wrapper || video;

    const handlePointerEnter = () => {
      if (shouldAutoPlayOnView()) return;
      playVideo();
    };
    const handlePointerLeave = () => {
      if (shouldAutoPlayOnView()) return;
      pauseVideo();
    };

    trigger.addEventListener('pointerenter', handlePointerEnter, { passive: true });
    trigger.addEventListener('pointerleave', handlePointerLeave, { passive: true });
    trigger.addEventListener('pointercancel', handlePointerLeave, { passive: true });

    const handleAutoPlay = () => {
      if (!cardContent) return;
      if (shouldAutoPlayOnView() && cardContent.classList.contains('is-inview')) {
        playVideo();
        return;
      }
      if (shouldAutoPlayOnView()) {
        pauseVideo();
      }
    };

    const handleResize = () => {
      if (shouldAutoPlayOnView()) {
        handleAutoPlay();
      } else {
        pauseVideo();
      }
    };

    if (cardContent) {
      const observer = new MutationObserver(handleAutoPlay);
      observer.observe(cardContent, { attributes: true, attributeFilter: ['class'] });
      handleAutoPlay();
      window.addEventListener('resize', handleResize, { passive: true });
    }
  });
}
